import { render } from "./FinalPriceCell.vue?vue&type=template&id=52e56570&scoped=true"
import script from "./FinalPriceCell.vue?vue&type=script&lang=js"
export * from "./FinalPriceCell.vue?vue&type=script&lang=js"

import "./FinalPriceCell.vue?vue&type=style&index=0&id=52e56570&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52e56570"]])

export default __exports__